import { Menu, type MenuGroupProps, Text } from "@overmap-ai/blocks"
import type { IssueTypePriority, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { IssuePriorityIcon } from "../Icons/IssuePriorityIcon"

export interface IssuePriorityGroupProps extends MenuGroupProps {
	priorities: Stored<IssueTypePriority>[]
	onSelectPriority: (priority: Stored<IssueTypePriority>) => void
}

export const IssuePriorityGroup = memo<IssuePriorityGroupProps>((props) => {
	const { ref, priorities, onSelectPriority, ...rest } = props

	return (
		<Menu.Group ref={ref} {...rest}>
			{priorities.map((priority) => (
				<Menu.Item key={priority.uuid} onSelect={() => onSelectPriority(priority)}>
					<IssuePriorityIcon priority={priority.uuid} />
					<Text className="truncate">{priority.name}</Text>
				</Menu.Item>
			))}
		</Menu.Group>
	)
})
IssuePriorityGroup.displayName = "IssuePriorityGroup"
